import imgasistencia from '../../../../../assets/images_optimized/no-hay-tareas_optimized.png';
import HeroAsistencia from '../../assistants/Components/HeroAsistencia';
/*/../../../assets/images_optimized/no-hay-tareas_optimized.png' */
function ScreenAsistencePrincipal() {
  return <HeroAsistencia img={imgasistencia} />;
}

export default ScreenAsistencePrincipal;
